// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"ChartMetricSelection-module__checkboxes___2ftv6","checkbox":"ChartMetricSelection-module__checkbox___2pvLn"};